import * as _ from 'underscore';
import { IUserInfo } from '../models/IUserInfo';
import { ILens, ILensDetail } from '../ServerApi/types/ILens';
import { MapperHelper } from './MapperHelper';
import { UserMapper } from './UserMapper';
import { ILensDetailInfo, ILensInfo } from '../models/ILensInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { FeatureFlags } from '../FeatureFlags';
import { ContentMapper } from './ContentMapper';

export module LensMapper {

  export function map(
    serverApiLens: ILens[],
    users: _.Dictionary<IUserInfo>,
    favoriteLens: _.Dictionary<any> = {},
  projects: _.Dictionary<INamedItemInfo>
  ): ILensInfo[] {
    const lensToProject = ContentMapper.getContentToProjectMap(ContentMapper.ContentTypeToTargetMap.lens, projects);
    return _.map(serverApiLens, (p: ILens) => {

      const lensInfo: ILensInfo = {
        id:                           p.id,
        name:                         p.name,
        owner:                        UserMapper.mapOne(users[p.ownerId]),
        updatedAt:                    MapperHelper.toDate(p.updatedAt),
        contentType:                  'lens',
        project: (FeatureFlags.refactorProjectEnabled) ? lensToProject[p.id] : projects[p.projectId]
      };
      return lensInfo;
    });
  }

  export function mapDetail(p: ILensDetail): ILensDetailInfo {
    return {
      id:                           p.id,
      name:                         p.name,
      owner:                        UserMapper.mapOne(p.owner),
      updatedAt:                    MapperHelper.toDate(p.updatedAt),
      contentType:                  'lens'
    };
  }
}
